// SignUp.jsx
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {  createUserWithEmailAndPassword  } from 'firebase/auth';
import {auth} from './../../config/firebase';

function SignUp() {

  const [formData, setFormData] = useState({
      name: '',
      email: '',
      password: '',
      passwordConfirm: '',
      token: '',
  });

  const [error, setError] = useState('');

  const navigate = useNavigate();

  const handleInputChange = (property) => (e) => {
    setFormData((prev) => ({ ...prev, [property]: e.target.value }));
  };

  const validateForm = () => {
    const emailPattern = /\S+@\S+\.\S+/;
    if (!emailPattern.test(formData.email)) {
        return 'Please enter a valid email address.';
    }
    if (formData.password.length < 6 || !/\d/.test(formData.password)) {
        return 'Password must be at least 6 characters long and include a number.';
    }
    if (formData.password !== formData.passwordConfirm) {
        return 'Passwords do not match.';
    }
    return '';
  };

  /**
   * Call when user attempts to create an account.
   */
  const handleSignUp = async(e) => {

    e.preventDefault();
    const validationError = validateForm();
    if (validationError) {
        setError(validationError);
        return;
    }

    await createUserWithEmailAndPassword(auth, formData.email, formData.password)
    .then((userCredential) => {
      // Signed in
      const user = userCredential.user;
      console.log('Successfully created an account', user);
      navigate("/signin") // navigate to login screen
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.log(errorCode, errorMessage);
      setError(errorMessage);
    });

    console.log('Form Submitted', formData);
    setError('');
  };

  return (
    <form className="space-y-6" onSubmit={handleSignUp}>
      {/* Form fields and buttons here */}
      {/* TODO: Don't forget to handle input changes with handleInputChange */}

      <div className="space-y-1">
        <label htmlFor="name" className="text-sm font-medium">
          Name
        </label>
        <input
          type="text"
          id="name"
          name="name"
          placeholder="Enter your first name"
          value={formData.name}
          onChange={handleInputChange('name')}
          className="block w-full rounded-lg border border-gray-200 px-5 py-3 leading-6 placeholder-gray-500 focus:border-primary-500 focus:ring focus:ring-primary-500 focus:ring-opacity-50 dark:border-gray-600 dark:bg-gray-800 dark:placeholder-gray-400 dark:focus:border-primary-500"
        />
      </div>

      <div className="space-y-1">
        <label htmlFor="email" className="text-sm font-medium">
          Email
        </label>
        <input
          type="email"
          id="email"
          name="email"
          placeholder="Enter your email"
          value={formData.email}
          onChange={handleInputChange('email')}
          className="block w-full rounded-lg border border-gray-200 px-5 py-3 leading-6 placeholder-gray-500 focus:border-primary-500 focus:ring focus:ring-primary-500 focus:ring-opacity-50 dark:border-gray-600 dark:bg-gray-800 dark:placeholder-gray-400 dark:focus:border-primary-500"
        />
      </div>

      <div className="space-y-1">
        <label htmlFor="password" className="text-sm font-medium">
          Password
        </label>
        <input
          type="password"
          id="password"
          name="password"
          placeholder="Choose a strong password"
          value={formData.password}
          onChange={handleInputChange('password')}
          className="block w-full rounded-lg border border-gray-200 px-5 py-3 leading-6 placeholder-gray-500 focus:border-primary-500 focus:ring focus:ring-primary-500 focus:ring-opacity-50 dark:border-gray-600 dark:bg-gray-800 dark:placeholder-gray-400 dark:focus:border-primary-500"
        />
      </div>

      <div className="space-y-1">
        <label
          htmlFor="password_confirm"
          className="text-sm font-medium"
        >
          Confirm Password
        </label>
        <input
          type="password"
          id="password_confirm"
          name="password_confirm"
          placeholder="Confirm your chosen password"
          value={formData.passwordConfirm}
          onChange={handleInputChange('passwordConfirm')}
          className="block w-full rounded-lg border border-gray-200 px-5 py-3 leading-6 placeholder-gray-500 focus:border-primary-500 focus:ring focus:ring-primary-500 focus:ring-opacity-50 dark:border-gray-600 dark:bg-gray-800 dark:placeholder-gray-400 dark:focus:border-primary-500"
        />
      </div>

      <div className="space-y-1">
        <label htmlFor="name" className="text-sm font-medium">
          Token
        </label>
        <input
          type="text"
          id="token"
          name="token"
          placeholder="Enter your token"
          value={formData.token}
          onChange={handleInputChange('token')}
          className="block w-full rounded-lg border border-gray-200 px-5 py-3 leading-6 placeholder-gray-500 focus:border-primary-500 focus:ring focus:ring-primary-500 focus:ring-opacity-50 dark:border-gray-600 dark:bg-gray-800 dark:placeholder-gray-400 dark:focus:border-primary-500"
        />
      </div>

      <div className="flex items-center">
        <input
          type="checkbox"
          id="terms"
          name="terms"
          className="size-4 rounded border border-gray-200 text-primary-500 focus:border-primary-500 focus:ring focus:ring-primary-500 focus:ring-opacity-50 dark:border-gray-600 dark:bg-gray-800 dark:ring-offset-gray-900 dark:checked:border-transparent dark:checked:bg-primary-500 dark:focus:border-primary-500"
        />
        <span className="ml-2 text-sm font-medium">
          I accept {' '}
          <Link
            href="/#"
            className="font-medium text-gray-600 underline hover:text-gray-500 dark:text-gray-400 dark:hover:text-gray-300"
          >
            terms &amp; conditions
          </Link>
        </span>
      </div>

      <div>
        {error && <p className="mb-4 text-sm text-red-500">{error}</p>}
        <button
          type="submit"
          className="inline-flex w-full items-center justify-center space-x-2 rounded-lg border border-teal-700 bg-teal-700 px-6 py-3 font-semibold leading-6 text-white hover:border-primary-600 hover:bg-primary-600 hover:text-white focus:ring focus:ring-primary-400 focus:ring-opacity-50 active:border-primary-700 active:bg-primary-700 dark:focus:ring-primary-400 dark:focus:ring-opacity-90"
        >
          Create Account
        </button>
      </div>

    </form>
  );
}

export default SignUp;
